import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const Container = styled.div`
    padding: 32px 122px;
`;

export const ContainerAddDependentes = styled.div`
    padding: 0 0 0 0;
`;

export const AddButton = styled.a`
    font-weight: bold;
    color: ${(props) => props.theme.orangeLink};
    text-decoration: underline;
    cursor: pointer;
    font-size: ${theme.font.size16};
    
    :hover{
        text-decoration: underline;
        color: ${(props) => props.theme.orangeLink};

    }
`;

export const CardQuestionAddDependentes = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.borderWhite} !important;
    border-radius: 8px;
    padding: 24px;

    h2 {
        margin: 0;
        margin-bottom: 24px;
        text-align: center;
        font-weight: bold;
        color: ${(props) => props.theme.black};
    }
`;

export const ContainerButtons = styled.div`
    display: flex;
    flex-direction: column;

    @media(min-width: 900px) {
        flex-direction: row;
        
        button:first-child {
            margin-right: 20px;
        }
    }
`;

export const LinkedButtonAlign = styled.div`
    padding: 8px 0 0 0;
    width: 100%;
`;

export const LinkButton = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 0 32px 0px;

    span[class*="material-icons"] {
        margin-right: 8px;
    }
`;

export const SectionContainer = styled.div`
    display: flex;
    width: 100%;

    @media screen and (max-width: 950px) {
        flex-direction: column;
    }
`;
